// src/components/UserTable.js
import React from 'react';

const UserTable = ({ users = [], onInvite }) => {
  return (
    <div className="user-table-wrapper">
      <div className="user-table-header">
        <h2>User Management</h2>
        <button className="invite-button" onClick={onInvite}>Invite Users</button>
      </div>

      <table className="user-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Role</th>
            <th>Status</th>
            <th>Joined</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {users.length === 0 ? (
            <tr>
              <td colSpan="5" style={{ textAlign: 'center' }}>No users found.</td>
            </tr>
          ) : (
            users.map((user) => (
              <tr key={user.uid}>
                <td className="user-cell">
                  <img
                    src={`https://ui-avatars.com/api/?name=${encodeURIComponent(user.name || '')}&background=0D8ABC&color=fff`}
                    alt="avatar"
                    className="user-avatar"
                  />
                  <div>
                    <div className="user-name">{user.name || 'No Name'}</div>
                    <div className="user-email">{user.email}</div>
                  </div>
                </td>
                <td>{user.role || '–'}</td>
                <td><span className="badge badge-green">Active</span></td>
                <td>{user.joined || '—'}</td>
                <td>⋯</td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      <div className="user-table-footer">
        <span>Showing {users.length} user{users.length !== 1 ? 's' : ''}</span>
        <div>
          Rows per page:
          <select>
            <option>10</option>
            <option>25</option>
            <option>50</option>
          </select>
        </div>
      </div>
    </div>
  );
};

export default UserTable;
